export default __webpack_public_path__ + "static/media/padlockIcon.0d750413.png";